










































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import axios from 'axios'
import { Toast } from 'vant'
const instance = axios.create({
  // headers: {'X-Custom-Header': 'foobar'}
})
import rtSelect from '@/components/estate/selectCom.vue'

const estateModule = namespace('estate')

@Component({
  components: {
    rtSelect
  }
})
export default class Form extends Vue {
  @estateModule.State('estateFeeTypeList') estateFeeTypeList!: any
  message: string = ''
  fileList: any = []
  serviceFee: any = ''
  materialFee: any = ''
  defaultIndex: number = 0
  feeType: number = 0
  feeName: string = '无偿维修'
  mounted() {
    this.getEstateMaintainFeeTypeList()
    // this.estateMaintainFeeitemList()
  }
  get action() {
    return this.$http['FILE_UPLOAD'].api
  }
  /**获取费用类型列表 */
  async getEstateMaintainFeeTypeList() {
    const { success } = await this.$store.dispatch(
      'estate/estateMaintainFeeTypeList',
      {}
    )
  }

  handleSumChange() {}

  uploadfiles(val: any, index: any) {
    //图文图片上传
    const param = new FormData()
    param.append('file', val.file)
    instance
      .post(this.action, param, {
        headers: {
          'Content-Type': 'multipart/form-data',
          token: this.$global.token,
          tenantId: this.$global.tenantId,
          tenantType: this.$global.tenantType
        }
      })
      .then(res => {
        if (res.data.status == 200) {
          if (res.data.data.path) {
            this.fileList.push({ url: res.data.data.path })
          }
        } else {
          Toast(res.data.message)
        }
      })
  }
  del(url: any) {
    let index = this.fileList.indexOf(url)
    this.fileList.splice(index, 1)
  }
  handleSelectFeeClick(item: any) {
    console.log(item)
    this.feeType = item.value
    this.feeName = item.name
  }
  /**创建 */
  handleCreateClick() {
    let urls: any = []
    this.fileList &&
      this.fileList.map((val: any) => {
        urls.push(val.url)
      })
    let par = {
      id: this.$route.query.id,
      processingResult: 30,
      processingDeclare: this.message,
      repairType: this.feeType,
      urls: urls,
      feeRecord: [
        {
          amount: this.serviceFee,
          feeItemId: 1
        },
        {
          amount: this.materialFee,
          feeItemId: 2
        }
      ]
    }
    if (this.feeType == 1) {
      if (this.serviceFee == '' || !this.serviceFee) {
        Toast('请输入服务费')
        return
      }
      if (this.materialFee == '' || !this.materialFee) {
        Toast('请输入材料费')
        return
      }
    }
    this.estateComplete(par)
  }
  async estateComplete(par: any) {
    const { error, success }: any = await this.$store.dispatch(
      'estate/estateMaintainComplete',
      par
    )
    if (success) {
      Toast('提交成功')
      this.$router.push('/estateWorker')
    }
    if (error) {
      Toast(error.msg)
    }
  }
}
